var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "dialog-fade" },
      on: { "after-enter": _vm.afterEnter, "after-leave": _vm.afterLeave }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.dialogShow,
              expression: "dialogShow"
            }
          ],
          staticClass: "dialogs",
          class: {
            "scrollable-dialog": _vm.screenHeight < 600 && _vm.screenWidth < 950
          },
          style: {
            paddingTop: _vm.paddingTop + "px",
            paddingBottom: _vm.paddingBut + "px"
          },
          attrs: { id: "dialogs" + _vm.randString }
        },
        [
          _c("div", { staticClass: "dialogs-content" }, [
            _c("div", { staticClass: "dialogs-header" }, [
              _c("div", [_vm._v(_vm._s(_vm.title))]),
              _c("i", {
                staticClass: "el-icon-close",
                on: { click: _vm.closeDialo }
              })
            ]),
            _c("div", { staticClass: "dialogs_body" }, [_vm._t("default")], 2),
            _c("div", { staticClass: "dialog_footer" }, [_vm._t("footer")], 2)
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }